<template>
    <div class="input__wrapper input__wrapper--address-autocomplete">
        <input type="text"
               :title="label"
               :placeholder="placeholder"
               :id="id"
               v-model="autocompleteText"
               @keyup="search($event.target)">
        <label :for="id">
            {{ label }}
        </label>
    </div>
</template>

<script>

    export default {

        name: "checkout-address-autocomplete",

        props: {
            id: {
                type: String,
                required: true
            },
            placeholder: {
                type: String
            },
            label: {
                type: String
            }
        },

        data() {
            return {
                autocompleteText: ''
            }
        },

        methods: {
            search(event){
                this.autocompleteText = event.value;
                this.onSearchKeyup();
            },

            onSearchKeyup() {
                this.$emit('changedSearch', this.autocompleteText);
            },
        }
    }

</script>
